import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'insert-edit-string',
  templateUrl: './string.component.html',
  styleUrls: ['./string.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ]
})
export class StringComponent {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() required: boolean = false;
  @Input() uppercase: boolean = false;
  @Input() capitalize: boolean = false;

  constructor(private formGroupDirective: FormGroupDirective) {}

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }

}
